<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              CIT for Cash Connect Enabled Locations
            </div>
          </template>
          <v-row>
            <v-spacer />
            <download-csv
              :name="csvfilename"
              :data="group_safe_dataCSV"
            >
              <v-btn color="info">
                <v-icon left>
                  mdi-arrow-down
                </v-icon>CSV
              </v-btn>
            </download-csv>
            <v-btn
              class="mr-2"
              color="warning"
              to="/reportsoperationgroups"
            >
              Return
            </v-btn>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="group_safe_data"
            :search="searchdaily"
            sort-by="day"
            sort-desc
            class="elevation-1"
          >
          
            <template v-slot:top>
                            <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startdate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="startdate"
                      @change="onChange($event)"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="enddate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="enddate"
                      scrollable
                      @change="onEndChange($event)"
                    />
                  </v-menu>
                </v-col>
                <v-spacer />
              </v-row>
              <v-toolbar
                flat
                color="white"
              >
                <v-toolbar-title>CIT by date, from date {{ startdate }} to {{ enddate }}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                />
                <v-text-field
                  v-model="searchdaily"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                />
              </v-toolbar>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              {{ format_amt(item.total) }}
            </template>
            <template v-slot:[`item.usage`]="{ item }">
              {{ format_percent(item.usage) }}
            </template>
            <template v-slot:no-data>
              <div class="display-2 font-weight-light">
                Sorry, no messages to display for Smart Safe ID {{ id }}
              </div>
              <br>
            </template>
          </v-data-table>
        </base-material-card>

        <div class="py-3" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    name: 'Reportgroupcit',
    props: ['id'],

    data () {
      return {
        date: '',
        date2: '',
        cit_data: {
          total_events: 0,
          total_cash: 0,
          total_co2: 0
        },
        under_25: '',
        BI_25: '',
        under_50: '',
        BI_50: '',
        under_75: '',
        BI_75: '',
        startdate: '',
        enddate: '',
        menu: false,
        menu1: false,
        filenamedate: '',
        searchdaily: '',
        loading: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        groupsites: [],
        headers: [
          { text: 'Day', value: 'day', align: 'left' },
          { text: 'group', value: 'group', align: 'left' },
          { text: 'Name', value: 'siteid', align: 'left' },
          { text: 'CC ID', value: 'ccid', align: 'left' },
          { text: 'Total', value: 'total', align: 'right' }
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs: 0,
      }
    },
    computed: {
      userisadmin () {
        if (
          this.$store.getters.user.status === 'admin' &&
          this.loading === false
        ) {
          return true
        }
        return false
      },
      dateRangeText () {
        return this.dates
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = this.startdate + 'to' + this.enddate + '_' + this.id + '.csv'
        return filename
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      group_safe_dataCSV () {
        console.log('group cit data ', this.$store.getters.setCITGroupValues)
        // this.total_cit(this.$store.getters.setCITGroupValues)
        // let events_under_25 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.25)
        // let events_under_50 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.50)
        // let events_under_75 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.75)
        // this.under_25 = events_under_25.length
        // this.under_25_BI(events_under_25)
        // this.under_50 = events_under_50.length
        // this.under_50_BI(events_under_50)
        // this.under_75 = events_under_75.length
        // this.under_75_BI(events_under_75)
        let pickups = this.$store.getters.setCITGroupValues
        let ccsites = this.$store.getters.getCashConnectSites
        pickups.forEach(entry => {
          let ccid = ''
          this.$store.getters.getCashConnectSites.forEach(site => {
            if (entry.siteid === site.idnum) {
              if (entry.override) {
                ccid = site.override
              } else {
                ccid = site.ccid
              }
              Object.assign(entry, { ccid: ccid })
            }
          })
        })
        let csvrows = []
        pickups.forEach(cit => {
          let rec = {
            date: cit.day,
            ccid: cit.ccid,
            group: cit.group,
            sitename: cit.siteid,
            total: cit.total
          }
          csvrows.push(rec)
        })
        return csvrows
      },
      group_safe_data () {
        console.log('group cit data ', this.$store.getters.setCITGroupValues)
        // this.total_cit(this.$store.getters.setCITGroupValues)
        // let events_under_25 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.25)
        // let events_under_50 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.50)
        // let events_under_75 = this.$store.getters.setCITGroupValues.filter(entry => entry.usage <= 0.75)
        // this.under_25 = events_under_25.length
        // this.under_25_BI(events_under_25)
        // this.under_50 = events_under_50.length
        // this.under_50_BI(events_under_50)
        // this.under_75 = events_under_75.length
        // this.under_75_BI(events_under_75)
        let pickups = this.$store.getters.setCITGroupValues
        let ccsites = this.$store.getters.getCashConnectSites
        pickups.forEach(entry => {
          let ccid = ''
          this.$store.getters.getCashConnectSites.forEach(site => {
            if (entry.siteid === site.idnum) {
              if (entry.override) {
                ccid = site.override
              } else {
                ccid = site.ccid
              }
              Object.assign(entry, { ccid: ccid })
            }
          })
        })
        return pickups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return this.$store.getters.usergroups
      },
      getlocs () {
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            this.$log.debug('****** loc is ', loc)
            name = loc.sitename
          }
          this.$log.debug(' &&&&&& our name is ', name)
          if (value.siteunitsprofile) {
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum,
              sitename: name,
              sitelabel: loc.sitename
            }
            this.groupsites.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.groupsites)
        return this.groupsites
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.$store.dispatch('loadccSites')

      this.loading = true
      this.id = this.$route.params.id
      this.id = 'Rainbow Shops'
      this.startdate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      this.enddate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      // let j = Object.keys(loadedprofiles)
      // get the units for this group for today
      this.date = moment().subtract(1, 'day').format('YYYY-MM-DD')
      this.filenamedate = this.date
      let listsites = this.$store.getters.getCashConnectSites.map(entry => entry.idnum)
      let params = {
        group: this.id,
        startdate: this.startdate,
        enddate: this.enddate,
        listsites: listsites
      }
      this.$store.dispatch('loadcccit', params)
    },
    methods: {
      total_cit (events) {
        let rec = [...new Set(events.map(data => moment(data.timestamp).format('YYYY-MM-DD')))].length
        this.cit_data.total_events = events.length
        this.cit_data.total_cash = events.reduce((a, b) => a + ((b['total']) || 0), 0)
        // sort by timestamp
        events.sort(function (x, y) {
          return x.s - y.s
        })
        this.startdate = moment(events[0].timestamp).format('YYYY-MM-DD')
        this.enddate = moment(events[events.length - 1].timestamp).format('YYYY-MM-DD')
      },
      under_25_BI (events) {
        let rec = {
          counting_fees: 0,
          opening_fees: 0,
          co2: 0,
          unique_pickupdays: 0,
          pickup_fees: 0
        }
        rec.unique_pickupdays = events.length
        rec.opening_fees = numeral(this.calcBagOpenFees(events)).format('$0,000.00')
        rec.counting_fees = numeral(this.calcCountFees(events)).format('$0,000.00')
        rec.pickup_fees = numeral(this.calcPickupFees(events)).format('$0,000.00')
        this.BI_25 = rec
      },
      under_50_BI (events) {
        let rec = {
          counting_fees: 0,
          opening_fees: 0,
          co2: 0,
          unique_pickupdays: 0,
          pickup_fees: 0
        }
        rec.unique_pickupdays = events.length
        rec.opening_fees = numeral(this.calcBagOpenFees(events)).format('$0,000.00')
        rec.counting_fees = numeral(this.calcCountFees(events)).format('$0,000.00')
        rec.pickup_fees = numeral(this.calcPickupFees(events)).format('$0,000.00')
        this.BI_50 = rec
      },
      under_75_BI (events) {
        let rec = {
          counting_fees: 0,
          opening_fees: 0,
          co2: 0,
          unique_pickupdays: 0,
          pickup_fees: 0
        }
        rec.unique_pickupdays = events.length
        rec.opening_fees = numeral(this.calcBagOpenFees(events)).format('$0,000.00')
        rec.counting_fees = numeral(this.calcCountFees(events)).format('$0,000.00')
        rec.pickup_fees = numeral(this.calcPickupFees(events)).format('$0,000.00')
        this.BI_75 = rec
      },
      calcPickupFees (events) {
        let cit = events.length
        let cost_per_cit = 54
        return cit * cost_per_cit
      },
      calcBagOpenFees (events) {
        let opening_fee = 4
        let openings = events.length
        return opening_fee * openings
        // number of events x bag open fee
      },
      calcCountFees (events) {
        let counting_fee_thousand = 1.50
        let sum = events.reduce((a, b) => a + ((b['total']) || 0), 0)
        let fee = (sum / 1000) * counting_fee_thousand
        return fee
      },
      onChange (value) {
        this.$refs.menu.save(value)
        this.$log.debug('value passed to on change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.filenamedate = newdate
        let params = {
          group: this.id,
          startdate: this.startdate,
          enddate: this.enddate
        }
        this.date = newdate
        this.$log.debug('new params ', params)
        let sd = moment(params.startdate, 'YYYY-MM-DD')
        let ed = moment(params.enddate, 'YYYY-MM-DD')
        let span = ed.diff(sd, 'days')
        if (span >= 0) {
          this.$store.dispatch('loadcccit', params)
        } else {
          this.$log.debug('set the snackbar error to true')
        }
      },
      onEndChange (value) {
        this.$refs.menu1.save(value)
        this.$log.debug('value passed to on end change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.filenamedate = newdate
        let params = {
          group: this.id,
          startdate: this.startdate,
          enddate: this.enddate
        }
        this.date = newdate
        this.$log.debug('new params ', params)
        let sd = moment(params.startdate, 'YYYY-MM-DD')
        let ed = moment(params.enddate, 'YYYY-MM-DD')
        let span = ed.diff(sd, 'days')
        if (span >= 0) {
          this.$store.dispatch('loadcccit', params)
        } else {
          this.$log.debug('set the snackbar error to true')
        }
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('DD-MM-YYYY HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      format_percent (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('0.0000%')
      },
      getsitesbygroup (group) {
        let grp = group
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let grp = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            grp = loc.group
          }
          this.$log.debug(' our group is ', value.group, ' passed was ', grp)
          if (value.siteunitsprofile && value.group === grp) {
            this.$log.debug('adding')
            let shop = {
              idnum: key,
              safeid: Object.values(value.siteunitsprofile)[0].crypto_idnum,
            }
            this.locations.push(shop)
          }
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
